import { Args, First, media } from '../../../utils/style-utils'

export function jackpotVerticalMediaQuery(first: First, ...args: Args) {
  return media.sm(first, ...args)
}
